// extracted by mini-css-extract-plugin
module.exports = {"container":"Stepper_container__1mYDb","alternativeLabel":"Stepper_alternativeLabel__1QdRa"};